import './scss/index.scss';
import { dcFactory } from 'dc';
import HubspotFormComponent from './js/hubspot-form-widget.component';

dcFactory.register(HubspotFormComponent);
